import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'
import { listChallenges } from 'api/challenges-v2'
import type { ChallengeCategory, ListChallengesResponse } from 'api/types'
import { ChallengeComputedState } from 'utils/challenges'

export const getCurrentChallenges = createApiThunk<{ data: Challenge[] }, void>({
  action: 'challenges',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_CURRENT_CHALLENGES,
})

export const getPastChallenges = createApiThunk<Challenge[], ChallengeRequestPayload>({
  action: 'challenges/past',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_PAST_CHALLENGES,
  getParams: (payload) => payload,
})

export const getChallenges = createApiThunk<
  ListChallengesResponse,
  { category?: ChallengeCategory[]; challengeComputedState?: ChallengeComputedState[] }
>({
  action: 'challenges',
  request: (payload) => listChallenges(payload),
})
